import React from 'react';
import TransitionLink from './TransitionLink';
import { useLanguage } from '../context/LanguageContext';
import { useTranslation } from '../translations/translations';

const projects = [
    {
        id: '1',
        title: 'Viva Rai2!',
        categoryKey: 'featuredCategoryBroadcast',
        year: '2023-2024',
        image: '/img/work1.png',
        link: '/work/1',
    },
    {
        id: '3',
        title: 'Ulisse — Alberto Angela',
        categoryKey: 'featuredCategoryVP',
        year: '2020-2022',
        image: '/img/work3.png',
        link: '/work/3',
    },
    {
        id: 'lifeos',
        title: 'LifeOS',
        categoryKey: 'featuredCategoryDev',
        year: '2025',
        image: '/img/code/lifeos_hero.png',
        link: '/code/lifeos',
    },
];

const FeaturedProjects = () => {
    const { language } = useLanguage();
    const t = useTranslation(language);

    return (
        <section className="w-full bg-black py-24 px-8 md:px-16">
            <div className="max-w-6xl mx-auto">
                <h2 className="text-sm font-mono text-white/40 tracking-widest uppercase mb-16">
                    {t('featuredProjectsTitle')}
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {projects.map((project) => (
                        <TransitionLink
                            key={project.id}
                            to={project.link}
                            className="group block border border-white/10 rounded-2xl overflow-hidden hover:border-orange-400/40 transition-colors duration-300"
                        >
                            <div className="w-full h-48 bg-white/5 overflow-hidden">
                                <img
                                    src={project.image}
                                    alt={project.title}
                                    className="w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500"
                                />
                            </div>
                            <div className="p-6">
                                <div className="flex items-center gap-4 mb-3">
                                    <span className="text-xs font-mono text-orange-400 tracking-widest uppercase">{t(project.categoryKey)}</span>
                                    <span className="text-xs font-mono text-white/30">{project.year}</span>
                                </div>
                                <h3 className="text-lg font-black text-white tracking-tight group-hover:text-orange-400 transition-colors duration-300">
                                    {project.title}
                                </h3>
                            </div>
                        </TransitionLink>
                    ))}
                </div>
                <div className="mt-10">
                    <TransitionLink
                        to="/works"
                        className="text-sm text-white/50 font-mono hover:text-orange-400 transition-colors duration-300 inline-flex items-center"
                    >
                        {t('featuredProjectsViewAll')}
                        <span className="ml-2">→</span>
                    </TransitionLink>
                </div>
            </div>
        </section>
    );
};

export default FeaturedProjects;
